import React, { useContext } from 'react';
import { OperationType } from '../types/SelectedOperation';
import { ProductAlertsContext } from '../ProductAlertsProvider';
import { AlertConfiguration } from '../AlertConfiguration';
import DeleteConfirmationModal from '../../common/DeleteConfirmationModal';
import { RunAlertConfirmationModal } from './RunAlertConfirmationModal';

type Props = {
  onAlertUpdate?: () => void;
};

export const SelectedOperationActions: React.FC<Props> = ({ onAlertUpdate }) => {
  const { selectedOperation, setSelectedOperation } = useContext(ProductAlertsContext);
  const closeModal = () => {
    setSelectedOperation(null);
  };

  const closeModalWithUpdate = () => {
    closeModal();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    onAlertUpdate?.();
  };

  switch (selectedOperation?.type) {
    case OperationType.CreateAlert:
      return (
        <AlertConfiguration
          isModalOpen={true}
          segmentId={selectedOperation.segmentId}
          hideModal={closeModal}
          onComplete={closeModalWithUpdate}
        />
      );

    case OperationType.EditAlert:
      return (
        <AlertConfiguration
          isModalOpen={true}
          alert={selectedOperation.alert}
          hideModal={closeModal}
          onComplete={closeModalWithUpdate}
        />
      );

    case OperationType.DeleteAlert:
      return (
        <DeleteConfirmationModal
          visible={true}
          itemName={selectedOperation.alert.alertName}
          onClose={closeModal}
          onConfirm={async () => {
            await selectedOperation.operation();
            closeModalWithUpdate();
          }}
        />
      );
    case OperationType.RunAlert:
      return (
        <RunAlertConfirmationModal
          visible={true}
          alertName={selectedOperation.alert.alertName}
          onClose={closeModal}
          closeModalWithUpdate={closeModalWithUpdate}
          onConfirm={selectedOperation.operation}
        />
      );
  }

  return null;
};
